module.exports = __webpack_public_path__ + "img/tag-search-types.0b5026e5.png";